module.exports = __webpack_public_path__ + "img/female.fec18da3.png";